import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PublicKudoContentObjectDataObject } from 'models/service';

export const getPublicKudo = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.get<PublicKudoContentObjectDataObject, ApiClientResponse<PublicKudoContentObjectDataObject>>(
    routes.kudos.get(id),
  );
